const styles = theme => ({
  main: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column'
  },
  MuiCircularProgress: {
    margin: '250px auto',
    display: 'block'
  },
  footer: {
    borderTop: '2px solid ' + theme.palette.primary.light,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  buildVersion: {
    marginRight: theme.spacing(1)
  }
})

export default styles
